import { OurPetPolicyLandlordStatus } from "./types/our-pet-policy";
import { PetScreeningStatus } from "./types/pet-screening";

// We are merging 2 enums here to make it easier to compare verified pets statuses
// no matter the vendor who is reporting, avoiding to have to check which vendor is being used
export const APPROVED_PET_STATUSES = [
  OurPetPolicyLandlordStatus.VERIFIED,
  PetScreeningStatus.active,
  PetScreeningStatus.recommended,
  PetScreeningStatus.conditionally_recommended
];

export const PetVerificationStatusMap = {
  [OurPetPolicyLandlordStatus.VERIFIED]: "Verified",
  [OurPetPolicyLandlordStatus.NOT_VERIFIED]: "Not verified",
  [OurPetPolicyLandlordStatus.NONE]: "None",
  [PetScreeningStatus.active]: "Active",
  [PetScreeningStatus.conditionally_recommended]: "Conditionally recommended",
  [PetScreeningStatus.declined]: "Declined",
  [PetScreeningStatus.draft]: "Draft",
  [PetScreeningStatus.expired]: "Expired",
  [PetScreeningStatus.non_responsive]: "Non responsive",
  [PetScreeningStatus.recommended]: "Recommended",
  [PetScreeningStatus.returned]: "Waiting for animal owner",
  [PetScreeningStatus.verifying]: "Verifying",
  [PetScreeningStatus.pending]: "Reviewing"
};
